import { render, staticRenderFns } from "./printReviewResults.vue?vue&type=template&id=6e104826&scoped=true"
import script from "./printReviewResults.vue?vue&type=script&lang=js"
export * from "./printReviewResults.vue?vue&type=script&lang=js"
import style0 from "./printReviewResults.vue?vue&type=style&index=0&id=6e104826&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e104826",
  null
  
)

export default component.exports